var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 312 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ranking-bar-gradient-light-mode",
    y1: 3,
    x2: "100%",
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c111b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#701516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#971914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#aa1917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#af1917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#b31a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#b82418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#be2e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#c13917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c54417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#cb4e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#cf5915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#d46314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d86d11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#de780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e28205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e68e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ec9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f0a400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f4af00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e8aa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#dba500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#cd9f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c09b06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b4950d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a79014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#9a8b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8d871e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#808222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#747f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#687b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5a7529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4e702a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#416b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#35662b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#29612a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1f5b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#175628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125126"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBar);
export default __webpack_public_path__ + "static/media/LightBar.372d58720925fdc60114b65ff1a210cb.svg";
export { ForwardRef as ReactComponent };